import React from 'react';

import classNames from 'classnames';

import classes from './LbToggleTabsList.module.scss';
import { TabOption, TabsConfig, TabValue } from '../types/TabsConfig';
import { useTabsContext } from '../context/TabsContext';

export type LbToggleTabsListProps = {
  tabsConfig: TabOption[] | TabsConfig[];
  fullWidth?: boolean;
  className?: string;
  size?: 'small' | 'medium';
  color?: 'primary' | 'white';
};

export const LbToggleTabsList = ({
  tabsConfig,
  fullWidth,
  className,
  size = 'medium',
  color = 'white',
}: LbToggleTabsListProps) => {
  const { value, onValueChange } = useTabsContext();

  const listClasses = classNames(className, classes.container, {
    [classes.fullWidth]: fullWidth,
    [classes.small]: size === 'small',
    [classes.medium]: size === 'medium',
    [classes.colorPrimary]: color === 'primary',
    [classes.colorWhite]: color === 'white',
  });

  const handleTabClick = (tabValue: TabValue) => {
    onValueChange(tabValue);
  };

  return (
    <div className={listClasses} role="tablist">
      {tabsConfig.map(
        (tab) =>
          !tab.hide && (
            <button
              type="button"
              role="tab"
              aria-selected={value === tab.value}
              aria-controls={`panel-${tab.value}`}
              id={`tab-${tab.value}`}
              className={classNames(classes.tab, {
                [classes.selected]: value === tab.value,
              })}
              disabled={tab.disabled}
              onClick={() => handleTabClick(tab.value)}
              key={tab.value}
            >
              {!!tab.icon && <span className={classes.icon}>{tab.icon}</span>}
              {!!tab.label && <span>{tab.label}</span>}
            </button>
          ),
      )}
    </div>
  );
};
